import { FilterComponent } from './tag/filters';
import InfinityScroll from '../components/infinityScroll';
import { updatePriceBlock } from '../components/utilities.js';
import setTopBar from '../components/topBar.js';

const Tag = {
  init: function () {
    setTopBar();
    FilterComponent.init();
    updatePriceBlock();
    InfinityScroll.init();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Tag.init();
})
